import React from 'react';
import { View } from 'react-native';
import { propTypes, defaultProps } from './propTypes';
import Slider from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import CarouselPagination from './CarouselPagination';
import { ensureInRange } from './ensureInRange';
const AutoPlaySlider = autoPlay(Slider);
export default class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this._handleIndexChanged = index => {
            this.setState({
                activeIndex: index,
            });
            if (this.props.onIndexChanged) {
                this.props.onIndexChanged(index);
            }
        };
        const activeIndex = ensureInRange(props.initialIndex, 0, props.data.length - 1);
        this.state = {
            activeIndex,
        };
    }
    render() {
        const { data, renderItem, autoplay, dotStyle, activeDotStyle, showsPagination } = this.props;
        const carouselPaginationProps = {
            activeIndex: this.state.activeIndex,
            numberOfPage: data.length,
            onDotClicked: this._handleIndexChanged,
            dotStyle,
            activeDotStyle,
        };
        const sliderProps = {
            enableMouseEvents: true,
            index: this.state.activeIndex,
            onChangeIndex: this._handleIndexChanged,
            autoplay: !!autoplay,
        };
        return (<View>
        <AutoPlaySlider {...sliderProps}>{data.map(renderItem)}</AutoPlaySlider>
        {showsPagination && <CarouselPagination {...carouselPaginationProps}/>}
      </View>);
    }
}
Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
